export default __webpack_public_path__ + "static/media/suspenso.97e38851.svg";